export const addUid = (f, i) => ({
  ...f,
  order: f.order ?? i,
  uid: f.key,
});
